import React, { useEffect, useState } from "react";
import axios from "axios";
import noImage from "../../../assets/images/settings/no-image.png";
import styles from "../Event/RoundVideoResultOne/CSS/RoundVideoResult.module.css";
import style2 from "../Event/RoundVideoResultFour/CSS/RoundVideoResult.module.css";
import "./TableStyle.css";
import Button from "../Event/RoundVideoResultFour/Component/Button";
import ReUseableAuditionHeaderTitle from "../../Reuseable/ReUseableAuditionHeaderTitle";
import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
import swal from "sweetalert";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Card from "../Event/RoundVideoResultThree/Component/Card";
import { Table } from "react-bootstrap";
import TablePaginationReuse from "../../Audition_static/Audition_admin/TablePaginationReuse";
import AuditionWildCardTable from "./AuditionWildCardTable";
import Back from "../Event/RoundVideoResultFour/Component/Back";

function WildcardResultProcess({
  auditionRoundInfo,
  wildcardParticipant,
  activeRound,
  eventId,
  wildcardInfo,
  getRoundAndVideos,
}) {
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    // <img src={LeftArrow} alt="prevArrow" {...props} />
    <FaArrowLeft {...props} />
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <FaArrowRight {...props} />
  );

  const [videoType, setVideoType] = useState("user_vote");
  const [count, setCount] = useState(1);
  const [filterNumber, setFilterNumber] = useState(1);
  const [wildcardMarkTrackings, setRoundMarkTrackings] = React.useState({});
  const [filterType, setFilterType] = useState("");

  const handleBackButton = () => {};
  const handleFilterNumberChange = (e) => {
    if (e.target.value < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
      setFilterNumber(1);
    } else {
      setFilterNumber(Number(e.target.value));
    }
  };
  const handleCountChange = (e) => {
    if (e.target.value < 0) {
      swal("Opps...", "Sorry input field short then 0", "error");
      setCount(1);
    } else {
      setCount(Number(e.target.value));
    }
  };

  function increment() {
    setCount(function (prevCount) {
      return (prevCount += 1);
    });
  }

  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }
  function incrementNumber() {
    setFilterNumber(function (prevFilterNumber) {
      return (prevFilterNumber += 1);
    });
  }

  function decrementNumber() {
    setFilterNumber(function (prevFilterNumber) {
      if (prevFilterNumber > 0) {
        return (prevFilterNumber -= 1);
      } else {
        return (prevFilterNumber = 0);
      }
    });
  }

  const viewResultByPercentage = () => {
    setFilterType("percentage");
    if (Number(count) < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
    } else {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundVideoResultByPercentage/${eventId}/${activeRound}/${count}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setRoundMarkTrackings(res.data?.percentageWildcardMarkTrackings);
            swal(
              "Success",
              "Found " +
                res.data?.percentageWildcardMarkTrackings.length +
                " user for the next round",
              "success"
            );
          }
        });
    }
  };

  const viewResultByFilterNumber = () => {
    setFilterType("number");
    if (Number(filterNumber) < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
    } else {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundVideoResultByFilterNumber/${eventId}/${activeRound}/${filterNumber}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setRoundMarkTrackings(res.data?.filterNumberBaseRoundMarkTrackings);
            swal(
              "Success",
              "Found " +
                res.data?.filterNumberBaseRoundMarkTrackings?.length +
                " user for the next round",
              "success"
            );
          }
        });
    }
  };

  const userSendToManager = () => {
    const fData = new FormData();
    fData.append("percentage_range", count);
    fData.append("filter_number", filterNumber);
    fData.append("filter_type", filterType);
    fData.append("audition_id", eventId);
    fData.append("round_info_id", activeRound);
    fData.append("type", videoType);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/wildcardResultSendToManager`, fData)
        .then((res) => {
          if (res.data?.status == 200) {
            swal("success", res.data?.message, "success");
            getRoundAndVideos();
          }
        });
    });
  };

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    nextArrow: <SlickArrowRight />,
    prevArrow: <SlickArrowLeft />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  /** For Table */
  const countPerPage = 10;
  const [value, setValue] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [collection, setCollection] = React.useState(
    cloneDeep(wildcardParticipant.slice(0, countPerPage))
  );
  const searchData = React.useRef(
    throttle((val) => {
      const query = val.toLowerCase();
      setCurrentPage(1);
      const data = cloneDeep(
        wildcardParticipant
          .filter(
            (item) =>
              item.participant?.last_name.toLowerCase().indexOf(query) > -1
          )
          .slice(0, countPerPage)
      );
      setCollection(data);
    }, 400)
  );

  useEffect(() => {
    if (!value) {
      updatePage(1);
    } else {
      searchData.current(value);
    }
  }, [value]);

  const updatePage = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setCollection(cloneDeep(wildcardParticipant.slice(from, to)));
  };

  const tableHead = ["Name", "Email", "Total React"];

  return (
    <>
      <div className="container-lg">
        <AuditionWildCardTable
          tableHead={tableHead}
          data={wildcardParticipant}
        />

        <ReUseableAuditionHeaderTitle
          isPrimary={false}
          title={
            "Round " +
            auditionRoundInfo.round_num +
            " - make result for next round"
          }
        />

        <div className="row mx-1 my-3 card-bg justify-content-center py-4">
          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
            <div className="card-bg px-3">
              <b className="text-light">Top</b>
            </div>
          </div>
          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
            <div className="d-flex card-bg px-3 justify-content-around">
              <button
                onClick={decrementNumber}
                className="btn btnDecrement bold"
              >
                <i class="fa-solid fa-minus"></i>
              </button>
              <input
                type="number"
                value={filterNumber}
                onChange={(e) => handleFilterNumberChange(e)}
                className="text-center border-0 from-control bg-black fw-bold btnInput"
              />
              <button
                onClick={incrementNumber}
                className="btn btnIncrement bold"
              >
                <i class="fa-solid fa-plus"></i>
              </button>
            </div>
          </div>
          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
            <div className="card-bg px-3">
              <b className="text-light">user qualify for the next round</b>
            </div>
          </div>
          <Button text={"View Result"} onClick={viewResultByFilterNumber} />
        </div>

        <div>
          <ReUseableAuditionHeaderTitle
            isPrimary={false}
            title={
              "Round " +
              auditionRoundInfo.round_num +
              " - make result for next round"
            }
          />

          <div className="row mx-1 my-3 card-bg justify-content-center py-4">
            <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
              <div className="card-bg px-3">
                <b className="text-light">Take</b>
              </div>
            </div>
            <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
              <div className="d-flex card-bg px-3 justify-content-around">
                <button onClick={decrement} className="btn btnDecrement bold">
                  <i class="fa-solid fa-minus"></i>
                </button>
                <input
                  type="number"
                  value={count}
                  onChange={(e) => handleCountChange(e)}
                  className="text-center border-0 from-control bg-black fw-bold btnInput"
                />
                <button onClick={increment} className="btn btnIncrement bold">
                  <i class="fa-solid fa-plus"></i>
                </button>
              </div>
            </div>
            <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
              <div className="card-bg px-3">
                <b className="text-light">
                  % mark gained user for the next round
                </b>
              </div>
            </div>
            <Button text={"View Result"} onClick={viewResultByPercentage} />
          </div>
        </div>

        {wildcardMarkTrackings.length > 0 ? (
          <div className="row justify-content-center align-items-center mt-5">
            <Card
              number={wildcardParticipant.length}
              title={"Total User"}
              cardText={"User"}
            />
            <Card
              number={wildcardMarkTrackings.length}
              title={"Qualify For The Next Round"}
              cardText={"User"}
            />
            <Card
              number={wildcardParticipant.length - wildcardMarkTrackings.length}
              title={"Disqualify For This Round"}
              cardText={"User"}
            />
            {Number(wildcardInfo?.status) != 1 ? (
              <Button text={"Already Sent To Manager"} />
            ) : (
              <>
                <div
                  onClick={userSendToManager}
                  style={{
                    margin: "40px 0px 40px",
                    textAlign: "center",
                  }}
                >
                  <Button text={"Approved Request For Manager"} />
                </div>
              </>
            )}
          </div>
        ) : (
          <></>
        )}
        <Back onClick={handleBackButton} />
      </div>
    </>
  );
}

export default WildcardResultProcess;
